import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for stored authentication
    const storedUser = localStorage.getItem('rentalPortalUser');
    const storedToken = localStorage.getItem('authToken');
    if (storedUser && storedToken) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const response = await authAPI.login(email, password);
      setUser(response.user);
      localStorage.setItem('rentalPortalUser', JSON.stringify(response.user));
      localStorage.setItem('authToken', response.token);
      return response.user;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  const signUp = async (email, password, name) => {
    try {
      const response = await authAPI.register(email, password, name);
      setUser(response.user);
      localStorage.setItem('rentalPortalUser', JSON.stringify(response.user));
      localStorage.setItem('authToken', response.token);
      return response.user;
    } catch (error) {
      console.error('Signup error:', error);
      throw error;
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('rentalPortalUser');
    localStorage.removeItem('authToken');
  };

  const value = {
    user,
    loading,
    login,
    signUp,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};